module.exports = __webpack_public_path__ + "static/img/our-people.8ceac49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/our-people.jpg
// module id = hi3s
// module chunks = 0